import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LoginButton = props => {
    var _a, _b;
    return (_jsxs("a", Object.assign({ className: `btn btn-eh btn-round ${props.className}`, href: props.href }, { children: [_jsx("img", { src: (_a = props.img) === null || _a === void 0 ? void 0 : _a.src, alt: (_b = props.img) === null || _b === void 0 ? void 0 : _b.alt, height: "42" }), " ", props.children] })));
};
